<template>
  <div class="appointDiv-view">
    <div class="top-cont">
      <div class="left" v-if="rowDataObj.info">
        <div class="left-div">
          {{ rowDataObj.info.license_plate }}
        </div>
      </div>
      <div class="right">
        {{ rowDataObj.company_name }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">选择厂区：</div>
      <div class="right">
        {{ rowDataObj.company_name }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.business">
      <div class="left">选择业务：</div>
      <div class="right">
        {{ rowDataObj.business.name }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.business">
      <div class="left">
        涉及{{ rowDataObj.business.type === 1 ? "产品线" : "业务子类" }}：
      </div>
      <div class="right">
        <div
          v-for="(item, index) in rowDataObj.business.sub_business"
          :key="index"
        >
          {{ item.name }}
          <span v-if="index !== rowDataObj.business.sub_business.length - 1"
            >、</span
          >
        </div>
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">预约时间：</div>
      <div class="right" v-if="rowDataObj.booking_time">
        {{ formatBookingTime(rowDataObj.booking_day) }}
        {{ rowDataObj.booking_time.begin_time }}-{{
          rowDataObj.booking_time.end_time
        }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">车牌号：</div>
      <div class="right" v-if="rowDataObj.info">
        {{ rowDataObj.info.license_plate }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">车辆类型：</div>
      <div class="right" v-if="rowDataObj.info">
        {{
          rowDataObj.info.vehicle_type === 0
            ? "--"
            : vehicleColumns[rowDataObj.info.vehicle_type - 1]
        }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.info">
      <div class="left">司机姓名：</div>
      <div class="right">
        {{ rowDataObj.info.name || "--" }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.info">
      <div class="left">司机身份证：</div>
      <div class="right">
        {{ rowDataObj.info.id_card || "--" }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.info">
      <div class="left">司机手机号：</div>
      <div class="right">
        {{ rowDataObj.info.contact || "--" }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">备注：</div>
      <div class="right">
        {{ rowDataObj.note || "--" }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">当前预约状态：</div>
      <div
        class="right"
        :style="`color: ${stateColor[Number(rowDataObj.state)]}`"
      >
        {{ stateOption[Number(rowDataObj.state)] || "--" }}
      </div>
    </div>

    <div class="mid-cont">
      <div style="margin-bottom: 14px;">司机身份证正反面照片：</div>
      <div style="display: flex;">
        <div style="flex: 1;justify-content: center;align-items: center;">
          <img
            class="card-img"
            :src="previewFileList[0]"
            @click="preview_img(previewFileList, 0)"
          />
        </div>
        <span style="width: 10px;display: inline-block;"></span>
        <div style="flex: 1;">
          <img
            class="card-img"
            :src="previewFileList[1]"
            @click="preview_img(previewFileList, 1)"
          />
        </div>
      </div>
    </div>

    <div class="mid-cont">
      <div style="margin-bottom: 14px;">驾驶证主页和副页照片：</div>
      <div style="display: flex;">
        <div style="flex: 1;justify-content: center;align-items: center;">
          <img
            class="card-img"
            :src="previewFileList[2]"
            @click="preview_img(previewFileList, 2)"
          />
        </div>
        <span style="width: 10px;display: inline-block;"></span>
        <div style="flex: 1;">
          <img
            class="card-img"
            :src="previewFileList[3]"
            @click="preview_img(previewFileList, 3)"
          />
        </div>
      </div>
    </div>

    <div class="mid-cont">
      <div style="margin-bottom: 14px;">行驶证主页和副页照片：</div>
      <div style="display: flex;">
        <div style="flex: 1;justify-content: center;align-items: center;">
          <img
            class="card-img"
            :src="previewFileList[4]"
            @click="preview_img(previewFileList, 4)"
          />
        </div>
        <span style="width: 10px;display: inline-block;"></span>
        <div style="flex: 1;">
          <img
            class="card-img"
            :src="previewFileList[5]"
            @click="preview_img(previewFileList, 5)"
          />
        </div>
      </div>
    </div>

    <!-- 预约状态：1未报到 2已报到 3报到失效 5已挂起 显示编辑和删除  其余情况隐藏 -->
    <div
      v-if="
        (Number(rowDataObj.state) === 1 ||
          Number(rowDataObj.state) === 2 ||
          Number(rowDataObj.state) === 3 ||
          Number(rowDataObj.state) === 5) &&
          ((privilegeConfig.keys &&
            privilegeConfig.keys.indexOf('c-car-apply-mine-mgr') >= 0) ||
            dirverOrCoopUnit)
      "
    >
      <div style="height: 128px;background-color: #f4f5f6;"></div>
      <div class="footer-cont2">
        <van-button
          type="primary"
          block
          class="btnStyle1"
          @click="
            $router.push({
              path: '/rhwxAppointModify/0?type=edit',
              query: {
                type: 'edit',
                pageType: 'detail',
                info_id: rowDataObj.info_id,
                id: rowDataObj.id,
                time1: time1,
                time2: time2,
                keyword: keyword
              }
            })
          "
          >编辑</van-button
        >
        <van-button block class="btnStyle2" @click="deleteAppoint"
          >删除</van-button
        >
      </div>
    </div>

    <van-dialog
      v-model="deleteShow"
      title="警告"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk">
          您正在删除“<span class="colorGreenLight">
            {{ rowDataObj.info.license_plate }} </span
          >”关于“<span class="colorGreenLight">
            {{ formatBookingTime(rowDataObj.booking_day) }}
            {{ rowDataObj.booking_time.begin_time }}-{{
              rowDataObj.booking_time.end_time
            }}</span
          >”的预约记录！<br />
          <span style="color: #FE3141;">删除后不可恢复！</span>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="confirmDelete">
            <van-button block class="dialogBtnConfirm">确认删除</van-button>
          </div>
          <div style="flex: 1;" @click="deleteShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
        </div>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { ImagePreview } from "vant";
import privilegeMixin from "@/mixins/rh/privilegeMixin.js";
export default {
  data() {
    return {
      deleteShow: false,
      rowDataObj: {},
      recentObj: {},
      vehicleColumns: ["平板车", "货柜车", "槽罐车", "其他", "高栏车"],
      previewFileList: [],
      stateOption: [
        "",
        "未报到",
        "已报到",
        "报到失效",
        "办理中",
        "已挂起",
        "已失效",
        "已关闭",
        "已完成",
        "已拒绝"
      ],
      stateColor: [
        "",
        "#B08931",
        "#00C8D2",
        "#666666",
        "#4F86F6",
        "#F5A623",
        "#666666",
        "#EC3F67",
        "#008B5E",
        "#EC3F67"
      ]
    };
  },
  mounted() {
    this.getList();
    // localStorage.removeItem("appointModify");
  },
  mixins: [privilegeMixin],
  methods: {
    preview_img(images, index) {
      ImagePreview({
        images: images, // 图片数组
        showIndex: true,
        loop: true,
        startPosition: index
        // closeable: true
      });
    },

    // 删除预约信息
    deleteAppoint() {
      this.deleteShow = true;
      // setTimeout(() => {
      //   Toast.success("删除成功");
      // }, 2000);
    },

    getList() {
      this.$common
        .http({
          url: "/api/queue/dispatcher/get_booking_detail",
          data: {
            info_id: this.info_id
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.previewFileList = [];
          this.rowDataObj = res.data.data;
          this.rowDataObj.file.forEach(item => {
            let index = "";
            if (Number(item.type) === 0) {
              index = 0;
            } else if (Number(item.type) === 1) {
              index = 1;
            } else if (Number(item.type) === 4) {
              index = 2;
            } else if (Number(item.type) === 5) {
              index = 3;
            } else if (Number(item.type) === 2) {
              index = 4;
            } else if (Number(item.type) === 3) {
              index = 5;
            }
            item.index = index;
            this.previewFileList.splice(item.index, 0, item.real_path);
            // this.previewFileList.push(item.real_path);
          });
        });
    },

    // 格式化预约时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    confirmDelete() {
      this.$common
        .http({
          url: "/api/queue/dispatcher/delete_booking",
          data: {
            id: this.id
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.$common.mbToastSuccess("删除成功");
          setTimeout(() => {
            this.$router.push({
              path: "/rhwxAppointList",
              query: {
                time1: this.time1,
                time2: this.time2,
                keyword: this.keyword
              }
            });
          }, 1000);
        });
    }
  },
  created() {},
  computed: {
    info_id() {
      return this.$route.query.info_id;
    },
    id() {
      return this.$route.query.id;
    },
    time1() {
      return this.$route.query.time1;
    },
    time2() {
      return this.$route.query.time2;
    },
    keyword() {
      return this.$route.query.keyword;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.appointDiv-view {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;
  font-size: 16px;
  .top-cont {
    display: flex;
    align-items: center;
    padding: 16px;
    background: #fff;
    .left {
      flex: 1.5;
      text-align: center;
      &-div {
        display: inline-block;
        background: #e5f3ee;
        padding: 5px 7px;
        color: #008b5e;
        margin-right: 14px;
        border-radius: 2px;
      }
    }
    .right {
      flex: 1;
      font-weight: bold;
    }
  }
  .top-cont-text {
    padding: 0px 16px 14px;
    background: #fff;
    display: flex;
    .left {
      // display: inline-block;
      // width: calc(36vw - 0px);
      flex: 1;
      text-align: right;
      margin-right: 40px;
      vertical-align: top;
      color: #b2b2b2;
    }
    .right {
      // display: inline-block;
      // width: calc(44vw - 0px);
      flex: 1.2;
      vertical-align: top;
      word-break: break-all;
    }
  }
  .mid-cont {
    background: #fff;
    margin-top: 10px;
    padding: 16px;
    font-size: 18px;
    color: #000000;
    line-height: 18px;
  }
  .card-img {
    object-fit: cover;
    // width: calc((100vw - 42px) / 2);
    width: 100%;
    height: calc((100vw - 42px) / 3.4);
    border-radius: 2px;
  }
  .dialog-blk {
    text-align: center;
    margin: 15px 17px 28px;
    font-size: 17px;
    color: #666666;
    line-height: 26px;
  }
}
</style>
<style lang="less">
.appointDiv-view {
  .van-dialog__header {
    opacity: 0.9;
    font-size: 17px;
    color: #000000;
    text-align: center;
  }
  .van-image__img {
    border-radius: 2px !important;
  }
}
</style>
